<template>
    <div   :style="{
        minWidth:isMobile?'auto':'1200px',
        backgroundColor: activeDetailData.currentPageConfig?.info?.backgroundColor,
        backgroundImage: activeDetailData.currentPageConfig?.info?.backgroundImage
            ? `url(${activeDetailData.currentPageConfig.info.backgroundImage})`
            : ''
    }" :class="{'page-wrap':isPage}" @contextmenu="onContextmenu">
        <div v-if="activeDetailData.currentPageConfig">
            <!-- <style id="viewCss" type="text/css">
            {{ currentPageConfig.info.cssText }}
          </style> -->
            <div v-for="(item, idx) in activeDetailData.currentPageConfig.elements" :key="idx">
                <element-item :disabled="!edit" :item-data="item" :idx="idx"
                    :allArcListMap="activeDetailData.allArcListMap" :parentKeys="[]"
                    :list-length="activeDetailData.currentPageConfig.elements.length"
                    :currentElementIndex="currentElementIndex" :current="idx + '' === currentElementIndexStr"
                    :pages="activeDetailData.pages"></element-item>
            </div>
        </div>
        <SiteEmpty v-else />
    </div>
</template>

<script setup>

import { computed, reactive } from 'vue';
import SiteEmpty from '~/components/common/SiteEmpty.vue';
import ElementItem from '~/components/render/ElementIndex.vue';




const props = defineProps({
    isMobile: {
        type: Boolean,
        default: false,
    },
    activeDetailData: {
        type: Object,
        default: () => ({}),
    },
    edit: {
        type: Boolean,
        default: false,
    },
    isPage: {
        type: Boolean,
        default: true,
    },
    currentElementIndex: {
        type: Array,
        default: () => ([]),
    },
    currentElementIndexStr: {
        type: String,
        default: "",
    },
});
const emit = defineEmits(['contextmenu'])
function onContextmenu(event) {
    emit("contextmenu", event)
}


</script>

<style scoped>
.page-wrap {
    min-height: 100vh;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center top;
}
</style>
